import clsx from 'clsx';
import type { ReactNode } from 'react';
import { Button, Icon } from '@ics-portal/guardian';
import { useGlobalUI } from '@contexts/GlobalUiContext';
import s from './AppSidebarToggle.module.scss';

export default function AppSidebarToggle(): ReactNode {
    const { setAppClassName, appClassName } = useGlobalUI();

    function toggleSidebar(): void {
        window.dispatchEvent(new Event('resize'));
        setAppClassName((prev) =>
            prev === 'expanded' ? 'collapsed' : 'expanded',
        );
    }

    const buttonClasses = clsx(
        s.toggleButton,
        appClassName === 'expanded' ? s.toggleButtonActive : null,
    );
    const iconClasses = clsx(
        s.icon,
        appClassName === 'expanded' ? s.expandedIcon : null,
    );

    return (
        <Button
            className={buttonClasses}
            onClick={toggleSidebar}
            title="Toggle sidebar width"
            type="button"
            icon={<Icon className={iconClasses} name="chevron_right" />}
        />
    );
}
